/** Auth session keys — DR-11 canonical host source for canvas authStorageKeys.ts. */

const AUTH_STORAGE_PREFIX = 'gaxl.auth.';

export const AUTH_ACCESS_TOKEN_KEY = `${AUTH_STORAGE_PREFIX}access_token`;
export const AUTH_SESSION_ID_KEY = `${AUTH_STORAGE_PREFIX}session_id`;
/** CMS / refresh-token auth flows (tc-gateway TokenPair). */
export const AUTH_REFRESH_TOKEN_KEY = `${AUTH_STORAGE_PREFIX}refresh_token`;
export const AUTH_PKCE_VERIFIER_KEY = `${AUTH_STORAGE_PREFIX}pkce_verifier`;
export const AUTH_CLIENT_ID_KEY = `${AUTH_STORAGE_PREFIX}client_id`;
/** Set before redirect to /login so LoginPage skips auto-OIDC redirect once. */
export const AUTH_LOGOUT_FLAG_KEY = `${AUTH_STORAGE_PREFIX}just_logged_out`;

export const USER_THEME_STORAGE_KEY = 'gaxl-user-theme';
export const SHELL_CONTEXT_STORAGE_KEY = 'gaxl-shell-context';

export const SHELL_EVENT_BUS_WINDOW_KEY = '__SHELL_EVENT_BUS__';
export const CANVAS_AWARENESS_STORE_WINDOW_KEY = '__CANVAS_AWARENESS_STORE__';
export const SOLUTION_RUN_STORE_WINDOW_KEY = '__SOLUTION_RUN_STORE__';
export const RESOLVING_TAB_WINDOW_KEY = '__RESOLVING_TAB__';
export const HOST_ADAPTERS_WINDOW_KEY = '__gaxl_host_adapters__';
